import { createFileRoute } from '@tanstack/react-router'
import { useGoBack } from '@/hooks/use-go-back'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { AppUserHelmetForm } from '@/features/app-user-helmets/components/app-user-helmet-form'
import { useRequireAdmin } from '@/features/auth'
import { Spinner } from '@/components/ui/spinner'
import { z } from 'zod'

const searchSchema = z.object({
  helmetId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/app-user-helmets/new')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const goBack = useGoBack()
  const { canAccess, isLoading } = useRequireAdmin('/app-user-helmets')
  const search = Route.useSearch()

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner className="size-8" />
      </div>
    )
  }
  if (!canAccess) return null

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/app-user-helmets' })}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold">Nuovo Casco Acquistato</h1>
      </div>
      <AppUserHelmetForm defaultHelmetId={search.helmetId} />
    </div>
  )
}
